// https://github.com/glidejs/glide
import Glide from '@glidejs/glide';

const carouselConfigs = {
    default: {
        type: 'carousel',
        gap: 0,
    },
    elementCarousel: {
        type: 'carousel',
        gap: 20,
        peek: 150,
        perView: 3,
        breakpoints: { // breakpoints are px value and lower
            599: {
                gap: 10,
                peek: 40,
                perView: 1,
            },
            767: {
                gap: 10,
                peek: 100,
                perView: 1,
            },
            979: {
                gap: 10,
                peek: 200,
                perView: 1,
            },
            1379: {
                gap: 20,
                peek: 150,
                perView: 2,
            },
        },
    },
};

export default function initCarousel(el) {
    const configString = el.getAttribute('data-config');
    new Glide(el, carouselConfigs[configString] || carouselConfigs.default).mount();
}

// this is necessary because Glide does not instantiate all elements by default
const carousels = document.querySelectorAll('.glide');
carousels.forEach(initCarousel);
